import React, { useState, ChangeEvent, useRef } from "react";
import { HttpPost, HttpPostFile } from "../../providers/HttpClient";
import Alert from "../alertComponent/alertComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { FaCar, FaUser, FaCalendarAlt, FaRegImage } from "react-icons/fa";
// import { MdCategory } from "react-icons/md";

interface ProductFormData {
  type: string;
  name: string;
  sender: string;
  date: string;
  note: string;
  firstPicture: File | null;
  //   category: string;
  //   categoryOwner: string;
  //   nameOwner: string;
  //   licenseNumber: string;
  //   date: string;
  //   note: string;
  //   firstPicture: File | null;
  //   secondInPicture: File | null;
}

const ProductRecordForm: React.FC = () => {
  const navigate = useNavigate();
  const [companyProfile, setCompanyProfile] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile")),
  );
  const [loading, setLoading] = useState(false);
  const [alertType, setAlertType] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [imageUrl1, setImageUrl1] = useState(null);
  const [image1, setImage1] = useState(null);
  const [imageUrl2, setImageUrl2] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const inputRef2 = useRef<HTMLInputElement | null>(null);
  const [imageName1, setImageName1] = useState("");
  const [imageName2, setImageName2] = useState("");
  const [photoTo, setPhotoTo] = useState("");
  const noteRef = useRef<HTMLTextAreaElement>(null);
  const [loadingImage1, setLoadingImage1] = useState(false);
  const [formData, setFormData] = useState<ProductFormData>({
    type: "",
    name: "",
    sender: "",
    date: "",
    note: "",
    firstPicture: null,
    // category: "",
    // categoryOwner: "",
    // nameOwner: "",
    // licenseNumber: "",
    // date: "",
    // note: "",
    // firstPicture: null,
    // secondInPicture: null,
  });

  const closeAction = async () => {
    setOpen(false);
    navigate("/home");
  };

  const alert = (message, type, subMessage) => {
    setOpen(true);
    setAlertMessage(message);
    setAlertType(type);
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClick = () => {
    inputRef?.current?.click();
    setPhotoTo("1");
  };

  const handleClick2 = () => {
    inputRef?.current?.click();
    setPhotoTo("2");
  };

  const uploadChoosenPhoto = async (event) => {
    let formData = new FormData();
    formData.append("image", event.target.files[0]);

    if (photoTo === "1") {
      setLoadingImage1(true);
    }
    // else if (photoTo === "2") {
    //   setLoadingImage2(true);
    // } else if (photoTo === "3") {
    //   setLoadingImage3(true);
    // }
    setLoading(true);
    HttpPostFile(`member/images?feature=log`, formData)
      .then((res: any) => {
        const file = event.target.files[0];
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);
        // setImageUrl1(previewUrl);
        if (photoTo === "1") {
          setImageUrl1(previewUrl);
          setImage1(res.data);
          setLoadingImage1(false);
        }
        if (photoTo === "2")
          return (setImageName2(res.data), setImageUrl2(res.data));
          // setLoadingImage2(false)
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    let data = {
      ...formData,
      date: formData.date,
      note: noteRef.current.value,
      firstPicture: image1,
    };

    setLoading(true);

    HttpPost("member/log_product", data)
      .then((res: any) => {
        setLoading(false);

        alert("Input Log Barang Berhasil", true, "");
      })
      .catch((err: any) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Alert
        type={alertType}
        isOpen={open}
        closeAction={closeAction}
        message={alertMessage}
        subMessage={""}
      />
      <header
        style={{ backgroundColor: companyProfile?.color }}
        className="text-white text-center py-5"
      >
        <h2 className="text-xl font-semibold">Pencatatan Barang</h2>
        <p className="text-sm opacity-80">Manajemen Keluar Masuk Barang</p>
      </header>
      <section id="main" className="bg-main h-full px-8 pb-24 -mt-28 z-50">
        <div className="mt-32 z-100 z-30 mb-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* <FaCalendarAlt className="inline-block mr-2 text-purple-600" /> */}
              Tanggal & Waktu
            </label>
            <input
              type="datetime-local"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nama Barang
            </label>
            <input
              type="text"
              name="name"
              placeholder="Masukkan nama barang"
              value={formData.name}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* <MdCategory className="inline-block mr-2 text-purple-600" /> */}
              Tipe
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            >
              <option value="">Pilih tipe</option>
              <option value="MASUK">Masuk</option>
              <option value="KELUAR">Keluar</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nama Pengirim
            </label>
            <input
              type="text"
              name="sender"
              placeholder="Masukkan nama pengirim"
              value={formData.sender}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Deskripsi
            </label>
            <textarea
              name="name"
              placeholder="Masukkan deskripsi"
              ref={noteRef}
              // onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>

          <div className="mb-4">
            <label className="text-sm font-light text-gray-400 mb-2">
              {/* <FaRegImage className="inline-block mr-2 text-purple-600" /> */}
              Foto 1
            </label>
            <div hidden={loadingImage1 == false}>
              <Skeleton
                containerClassName="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                baseColor="#000000"
                highlightColor="#363434"
                className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                style={{ borderRadius: 12 }}
              />
            </div>
            {loadingImage1 == false ? (
              <div
                // key={num}
                onClick={() => handleClick()}
                className="border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center p-6 mb-3 text-gray-500 cursor-pointer hover:border-purple-500"
              >
                <img
                  hidden={!imageUrl1}
                  src={imageUrl1 ? `${imageUrl1}` : null}
                  className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                />
                <input
                  type="file"
                  ref={inputRef}
                  accept="image/*"
                  capture
                  style={{ display: "none" }}
                  id="photo"
                  name="photo"
                  // onChange={inputHandler}
                  onChange={(event) => uploadChoosenPhoto(event)}
                  placeholder="pilih foto"
                />
                <label
                  // htmlFor={`photo`}
                  className="flex flex-col items-center cursor-pointer"
                >
                  {/* <FaRegImage className="text-3xl mb-2 text-gray-400" /> */}
                  <span>Tap untuk mengambil foto (Foto)</span>
                </label>
              </div>
            ) : null}
          </div>
        </div>
      </section>
      <div className="fixed bottom-0 w-full bg-white px-4 py-5 z-[9999]">
        {loading ? (
          <button
            disabled
            type="submit"
            className="w-full text-white font-semibold py-3 rounded-lg hover:bg-purple-800 bg-gray-300 transition"
          >
            Simpan Data
          </button>
        ) : (
          <button
            style={{ backgroundColor: companyProfile?.color }}
            disabled={loading}
            onClick={handleSubmit}
            type="submit"
            className="w-full text-white font-semibold py-3 rounded-lg hover:bg-purple-800 transition"
          >
            Simpan Data
          </button>
        )}
      </div>
    </>
  );
};

export default ProductRecordForm;
